export default "__VITE_ASSET__D1x6gluQ__"